<table>
  <thead>
    <tr>
      <th *ngFor="let column of columns" [style.text-align]="column.align || 'left'" [class]="column.cssClass" [class.sortable]="column.sortable !== false" [class.sorted]="sortColumn === column.key" (click)="onSort(column)">
        <ng-container *ngIf="hasCustomHeaderTemplate(column); else defaultHeader">
          <ng-container *ngTemplateOutlet="getCustomHeaderTemplate(column)!; context: { column: column }"></ng-container>
        </ng-container>
        <ng-template #defaultHeader>
          <span class="header-content">
            <span class="header-label">{{ column.label | translate }}</span>
            <mat-icon class="sort-icon" *ngIf="column.sortable !== false">{{ getSortIcon(column) }}</mat-icon>
          </span>
        </ng-template>
      </th>
      <th *ngIf="showDeleteAction" class="actions-column fit-content"></th>
    </tr>
  </thead>
  <tbody cdkDropList [cdkDropListData]="rows" cdkDropListOrientation="vertical" [cdkDropListDisabled]="!draggableRows" (cdkDropListDropped)="onRowDrop($event)">
    <tr *ngFor="let row of rows" (click)="onRowClick(row)" [class.clickable-row]="rowClick.observers.length > 0" class="table-row" cdkDrag [cdkDragDisabled]="!draggableRows" [cdkDragData]="row" cdkDragPlaceholderClass="drag-placeholder-row">
      <ng-template cdkDragPreview>
        <div class="custom-drag-preview">
          <span>{{ row?.dragPreviewLabel || '' }}</span>
        </div>
      </ng-template>

      <td *ngFor="let column of columns" [style.text-align]="column.align || 'left'" [class]="column.cssClass">
        <div class="cell-content" [class.cell-has-handle]="draggableRows && column.key === 'index'">
          <mat-icon *ngIf="draggableRows && column.key === 'index'" cdkDragHandle class="drag-handle-icon" aria-hidden="true">drag_indicator</mat-icon>
          <ng-container *ngIf="hasCustomTemplate(column); else defaultCell">
            <ng-container *ngTemplateOutlet="getCustomTemplate(column)!; context: { $implicit: row, column: column }"></ng-container>
          </ng-container>
        </div>
        <ng-template #defaultCell>
          <span [innerHTML]="getValue(row, column.key)"></span>
        </ng-template>
      </td>
      <td *ngIf="showDeleteAction" class="actions-column fit-content" (click)="$event.stopPropagation()">
        <button mat-icon-button class="delete-button" (click)="onDeleteClick(row)" type="button">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </tr>
  </tbody>
</table>
